// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2qbQW","options":"AnswerScale_options__3TxqY","selected":"AnswerScale_selected__18sMe"};